import { get } from '../utils/api';

class CommercialLeaseTypesService {
  getAll(organizationId: string, options?: Object) {
    return get(`/${organizationId}/commercial-lease-types`, options);
  }
}

export default CommercialLeaseTypesService;
